module.exports = __webpack_public_path__ + "img/logo.752ef44b.png";